import { render, staticRenderFns } from "./qxc.vue?vue&type=template&id=b29afeb0"
import script from "./qxc.vue?vue&type=script&lang=js"
export * from "./qxc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports